import React, { Component } from 'react';

import { buildPath } from '../utils/route_utils'
import { updateSEO } from '../utils/seo_utils'

import Navbar from '../components/Navbar'
import AnnouncementBanner from '../components/AnnouncementBanner'
import OpenSlideShow from '../components/OpenSlideShow'
import HeroProducts from '../components/HeroProducts'
import TrustSection from '../components/TrustSection'
import WhyNexuniSection from '../components/WhyNexuniSection'
import TestimonialSection from '../components/TestimonialSection'
import CollabProcessSection from '../components/CollabProcessSection'
import Footer from '../components/Footer'

import '../css/MainPage.css';

class MainPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang
    }

    this.navigate = this.navigate.bind(this)
    this.update_lang = this.update_lang.bind(this)
  }

  componentDidMount() {
    updateSEO('home', this.state.lang, '/' + this.state.lang + '/');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
      updateSEO('home', nextProps.lang, '/' + nextProps.lang + '/');
    }
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  render() {
        return (
          <div className={this.state.lang} >
            <AnnouncementBanner lang={this.state.lang} />
            <Navbar lang={this.state.lang} updateLangFunc={this.update_lang} />
            <OpenSlideShow lang={this.state.lang} navigate={this.navigate} />
            <TrustSection lang={this.state.lang} navigate={this.navigate} />
            <HeroProducts lang={this.state.lang} navigate={this.navigate} />
            <WhyNexuniSection lang={this.state.lang} navigate={this.navigate} />
            <TestimonialSection lang={this.state.lang} />
            <CollabProcessSection lang={this.state.lang} navigate={this.navigate} />
            <Footer lang={this.state.lang} navigate={this.navigate}/>
          </div>
        )
  }

}

export default MainPage;
